import React, { useContext } from 'react';
/*
  EmceeAppInstallCache provides a way for products/Application to pass
  prefetched datas like: hostLicense, appIdentifier, scopesLookUp
  Also, If either of these values are supplied then we won't fetch
  it again.
  This is mostly done keeping in mind EMCEE since it already has
  all these data and re-fetching will add latency to the modal
*/
export const EmceeAppInstallCache = /*#__PURE__*/React.createContext(null);
export const useEmceeAppInstallCache = () => {
  const cache = useContext(EmceeAppInstallCache);
  if (cache && Object.keys(cache).length) return cache;
  return null;
};